(function () {
  'use strict';

  var PENDING_CHECKOUT_KEY = 'bbPendingCheckoutItems';

  /* ---------- If the customer comes back from checkout without completing it, remove the quantities this flow added ---------- */
  function cleanupAbandonedCheckoutItems() {
    var raw;
    try {
      raw = sessionStorage.getItem(PENDING_CHECKOUT_KEY);
    } catch (e) {
      return;
    }
    if (!raw) return;

    try {
      sessionStorage.removeItem(PENDING_CHECKOUT_KEY);
    } catch (e) {
      /* ignore */
    }

    var addedQuantities;
    try {
      addedQuantities = JSON.parse(raw);
    } catch (e) {
      addedQuantities = null;
    }
    if (!addedQuantities || !Object.keys(addedQuantities).length) return;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var updates = {};
        Object.keys(addedQuantities).forEach(function (variantId) {
          var line = (cart.items || []).filter(function (it) {
            return String(it.variant_id) === String(variantId);
          })[0];
          if (!line) return;
          updates[variantId] = Math.max(0, line.quantity - addedQuantities[variantId]);
        });
        if (!Object.keys(updates).length) return;

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ updates: updates }),
        });
      })
      .catch(function (err) {
        console.error('Bundle Builder: failed to remove abandoned checkout items', err);
      });
  }

  cleanupAbandonedCheckoutItems();
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) cleanupAbandonedCheckoutItems();
  });

  /* ---------- Force the theme's cart drawer/notification closed and hidden while we hand off to checkout ---------- */
  function suppressCartPopup() {
    document.body.classList.add('bb-suppress-cart-popup');
    document.body.classList.remove('overflow-hidden');

    var targets = [document.querySelector('cart-drawer'), document.querySelector('cart-notification')].filter(Boolean);
    if (!targets.length) return;

    targets.forEach(function (el) {
      el.classList.remove('active', 'animate');
      if (typeof el.close === 'function') {
        try {
          el.close();
        } catch (e) {
          /* ignore */
        }
      }
    });

    var observer = new MutationObserver(function () {
      var stillOpen = false;
      targets.forEach(function (el) {
        if (el.classList.contains('active') || el.classList.contains('animate')) {
          el.classList.remove('active', 'animate');
          stillOpen = true;
        }
      });
      if (stillOpen) document.body.classList.remove('overflow-hidden');
    });
    targets.forEach(function (el) {
      observer.observe(el, { attributes: true, attributeFilter: ['class'] });
    });
    window.setTimeout(function () {
      observer.disconnect();
    }, 4000);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function initBundleBuilder(root) {
    var sectionId = root.id.replace('BundleBuilder-', '');
    var config = (window.bundleBuilderSettings && window.bundleBuilderSettings[sectionId]) || {};
    var tier2Percent = config.tier2Percent || 20;
    var tier3Percent = config.tier3Percent || 30;
    var tier2DiscountCode = config.tier2DiscountCode || 'BUY2GET20';
    var tier3DiscountCode = config.tier3DiscountCode || 'BUY3GET30';
    var moneyFormat = config.moneyFormat || '${{amount}}';
    var reminderTemplate = config.reminderTemplate || 'Add [count] item[plural] to get [percent]% off';
    var reminderMax = config.reminderMax || "You've unlocked the maximum discount!";
    var discountMessageTemplate = config.discountMessageTemplate || "You're saving [amount] on this set • [percent]% off applied";
    var editVariantLabel = config.editVariantLabel || 'Edit';
    var expandLabel = config.expandLabel || 'Expand';
    var collapseLabel = config.collapseLabel || 'Collapse';

    var stickyBar = root.querySelector('[data-bb-sticky]');
    var stickyExpand = root.querySelector('[data-bb-sticky-expand]');
    var itemRowTemplate = root.querySelector('[data-bb-item-row-template]');

    var state = { items: [] };
    var paginationState = new WeakMap();

    /* ---------- Money formatting ---------- */
    function formatMoney(cents) {
      cents = Math.round(cents || 0);
      var value = (cents / 100).toFixed(2);
      var parts = value.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var formatted = parts.join('.');
      var withoutDecimals = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      var out = moneyFormat;
      out = out.replace(/\{\{\s*amount_no_decimals\s*\}\}/, withoutDecimals);
      out = out.replace(/\{\{\s*amount\s*\}\}/, formatted);

      var tmp = document.createElement('div');
      tmp.innerHTML = out;
      return tmp.textContent || out;
    }

    function totalQuantity() {
      return state.items.reduce(function (sum, item) {
        return sum + (item.quantity || 1);
      }, 0);
    }

    function subtotalCents() {
      return state.items.reduce(function (sum, item) {
        return sum + item.price * (item.quantity || 1);
      }, 0);
    }

    function getDiscountPercent(qty) {
      if (qty >= 3) return tier3Percent;
      if (qty === 2) return tier2Percent;
      return 0;
    }

    /* ---------- Tabs ---------- */
    root.querySelectorAll('[data-bb-tab]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-bb-tab');
        root.querySelectorAll('[data-bb-tab]').forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        root.querySelectorAll('[data-bb-panel]').forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-bb-panel') === target);
        });
      });
    });

    /* ---------- Category tabs (Choose Your Own) ---------- */
    root.querySelectorAll('[data-bb-category-tab]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-bb-category-tab');
        root.querySelectorAll('[data-bb-category-tab]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        root.querySelectorAll('[data-bb-category-panel]').forEach(function (panel) {
          var match = panel.getAttribute('data-bb-category-panel') === id;
          panel.hidden = !match;
          if (match) {
            var searchInput = panel.querySelector('[data-bb-search]');
            var clearSearchBtn = panel.querySelector('[data-bb-search-clear]');
            var pagination = paginationState.get(panel);
            if (searchInput) {
              searchInput.value = '';
            }
            if (clearSearchBtn) {
              clearSearchBtn.hidden = true;
            }
            if (pagination) {
              pagination.search = '';
              pagination.page = 0;
            }
            renderPagination(panel);
          }

        });
      });
    });

    /* ---------- Pagination (shared by Curated Sets grid + each category grid) Start ---------- */
    /* ---------- Pagination + Search ---------- */
    function initPagination(wrap) {
      var perPage = parseInt(wrap.getAttribute('data-per-page'), 10) || 6;

      paginationState.set(wrap, { page: 0, perPage: perPage, search: ''});

      var prevBtn = wrap.querySelector('[data-bb-prev]');
      var nextBtn = wrap.querySelector('[data-bb-next]');
      var track = wrap.querySelector('.bb-pagination__track');

      /* ---------- Search ---------- */
      var searchInput = wrap.querySelector('[data-bb-search]');
      var searchWrap = wrap.querySelector('[data-bb-search-wrap]');
      var clearSearchBtn = wrap.querySelector('[data-bb-search-clear]');

      if (searchInput) {
        searchInput.addEventListener('input', function () {
          var s = paginationState.get(wrap);
          if (!s) return;

          s.search = searchInput.value.trim().toLowerCase();
          s.page = 0;

          if (clearSearchBtn) {
            clearSearchBtn.hidden = !searchInput.value;
          }

          renderPagination(wrap);
        });
      }

      if (clearSearchBtn) {
        clearSearchBtn.addEventListener('click', function () {
          if (!searchInput) return;

          searchInput.value = '';

          var s = paginationState.get(wrap);
          if (s) {
            s.search = '';
            s.page = 0;
          }

          clearSearchBtn.hidden = true;

          renderPagination(wrap);
          searchInput.focus();
        });
      }

      /* ---------- Previous ---------- */
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          var s = paginationState.get(wrap);

          if (s && s.page > 0) {
            s.page -= 1;
            renderPagination(wrap);
          }
        });
      }

      /* ---------- Next ---------- */
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          var s = paginationState.get(wrap);
          if (!s) return;

          var items = getFilteredItems(wrap);
          var totalPages = Math.max(
            1,
            Math.ceil(items.length / s.perPage)
          );

          if (s.page < totalPages - 1) {
            s.page += 1;
            renderPagination(wrap);
          }
        });
      }

      /* ---------- Pagination Track ---------- */
      if (track) {
        track.addEventListener('click', function (e) {
          var s = paginationState.get(wrap);
          if (!s) return;
          var items = getFilteredItems(wrap);
          var totalPages = Math.max(1, Math.ceil(items.length / s.perPage));
          if (totalPages <= 1) {
            return;
          }
          var rect = track.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          var ratio = clickX / rect.width;
          ratio = Math.max(0, Math.min(1, ratio));
          var page = Math.floor(ratio * totalPages);
          page = Math.max(0, Math.min(page, totalPages - 1));
          if (s.page !== page) {
            s.page = page;
            renderPagination(wrap);
          }
        });
      }

      /* ---------- Initial render ---------- */
      renderPagination(wrap);
    }
    /* ---------- Get filtered items ---------- */
    function getFilteredItems(wrap) {
      var s = paginationState.get(wrap);
      if (!s) {
        return [];
      }
      var items = Array.prototype.slice.call(
        wrap.querySelectorAll('[data-bb-page-item]')
      );
      if (!s.search) {
        return items;
      }
      return items.filter(function (item) {
        var name = (
          item.getAttribute('data-bb-name') || ''
        ).toLowerCase();

        return name.indexOf(s.search) !== -1;
      });
    }
    /* ---------- Render Pagination + Search ---------- */
    function renderPagination(wrap) {
      var s = paginationState.get(wrap);
      if (!s) {
        return;
      }
      var allItems = Array.prototype.slice.call(
        wrap.querySelectorAll('[data-bb-page-item]')
      );
      var filteredItems = getFilteredItems(wrap);
      var total = filteredItems.length;
      var totalPages = Math.max(1,Math.ceil(total / s.perPage));

      /* ---------- Show / hide search ---------- */
      var searchWrap = wrap.querySelector('[data-bb-search-wrap]');
      if (searchWrap) {
        searchWrap.hidden = allItems.length <= s.perPage;
      }

      /* ---------- Prevent invalid page ---------- */
      if (s.page < 0) {
        s.page = 0;
      }
      if (s.page > totalPages - 1) {
        s.page = totalPages - 1;
      }

      /* ---------- Current page range ---------- */
      var start = s.page * s.perPage;
      var end = start + s.perPage;

      /* ---------- Hide every item first ---------- */
      allItems.forEach(function (item) {
        item.style.display = 'none';
      });

      /* ---------- Show filtered items ---------- */
      filteredItems.forEach(function (item, index) {
        if (index >= start && index < end) {
          item.style.display = '';
        }
      });

      /* ---------- No results ---------- */
      var noResults = wrap.querySelector(
        '[data-bb-search-no-results]'
      );

      if (!noResults) {
        noResults = document.createElement('div');
        noResults.className = 'bb-search__no-results';
        noResults.setAttribute('data-bb-search-no-results','');
        noResults.textContent = 'No products found.';
        noResults.hidden = true;

        var grid = wrap.querySelector('[data-bb-grid]');

        if (grid) {
          grid.appendChild(noResults);
        }
      }

      noResults.hidden = !(s.search && total === 0);

      /* ---------- Pagination Visibility ---------- */
      var paginationEl = wrap.querySelector('[data-bb-pagination]');
      var showPagination = total > s.perPage;
      if (paginationEl) {
        paginationEl.classList.toggle('is-visible',showPagination);
      }

      /* ---------- Pagination Bar ---------- */
      var bar = wrap.querySelector('[data-bb-pagination-bar]');
      if (bar) {
        var progress = total > 0 ? ((s.page + 1) / totalPages) * 100 : 0;
        bar.style.width = progress + '%';
      }

      /* ---------- Counter ---------- */
      var counter = wrap.querySelector('[data-bb-pagination-counter]');
      if (counter) {
        if (total === 0) {
          counter.textContent = '0/0';
        } else {
          counter.textContent =
            Math.min(end, total) + '/' + total;
        }
      }

      /* ---------- Previous Button ---------- */
      var prevBtn = wrap.querySelector('[data-bb-prev]');
      if (prevBtn) {
        prevBtn.disabled = s.page <= 0 || total === 0;
      }

      /* ---------- Next Button ---------- */
      var nextBtn = wrap.querySelector('[data-bb-next]');
      if (nextBtn) {
        nextBtn.disabled = total === 0 || s.page >= totalPages - 1;
      }
    }
    root.querySelectorAll('[data-bb-grid-wrap]').forEach(
      initPagination
    );
    /* ---------- Pagination + Search End ---------- */
    /* ---------- Pagination (shared by Curated Sets grid + each category grid) End ---------- */

    /* ---------- Swatches ---------- */
    root.querySelectorAll('[data-bb-swatches]').forEach(function (swatchWrap) {
      var card = swatchWrap.closest('.bb-card');
      swatchWrap.querySelectorAll('[data-bb-swatch]').forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          swatchWrap.querySelectorAll('[data-bb-swatch]').forEach(function (s) {
            s.classList.toggle('is-active', s === swatch);
          });
          var variantId = swatch.getAttribute('data-variant-id');
          var price = swatch.getAttribute('data-price');
          var label = swatch.getAttribute('aria-label');
          card.setAttribute('data-bb-variant-id', variantId);
          card.setAttribute('data-bb-price', price);
          if (label) card.setAttribute('data-bb-variant-label', label);
          var priceEl = card.querySelector('[data-bb-card-price]');
          if (priceEl) priceEl.textContent = formatMoney(parseFloat(price));
        });
      });
    });

    /* ---------- Accordions ("What's included") ---------- */
    root.querySelectorAll('[data-bb-accordion]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.nextElementSibling;
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (panel) panel.classList.toggle('is-open', !expanded);
      });
    });

    /* ---------- Add / remove from the product grids ---------- */
    root.querySelectorAll('[data-bb-add]').forEach(function (btn) {
      btn.setAttribute('data-original-label', btn.textContent);
      btn.addEventListener('click', function () {
        var card = btn.closest('.bb-card');
        if (!card) return;
        var type = card.getAttribute('data-bb-type');
        var groupKey = type + ':' + card.getAttribute('data-bb-id');

        var alreadyAdded = state.items.some(function (item) {
          return item.groupKey === groupKey;
        });

        if (alreadyAdded) {
          removeGroup(groupKey);
          return;
        }

        if (type === 'set') {
          [1, 2, 3, 4].forEach(function (n) {
            var variantId = card.getAttribute('data-bb-variant-' + n);
            if (!variantId) return;
            var swatchesTemplate = card.querySelector('[data-bb-variant-swatches][data-bb-set-index="' + n + '"]');
            var swatchesSource = swatchesTemplate ? swatchesTemplate.content.querySelector('.bb-card__swatches') : null;
            state.items.push({
              key: 'product:' + variantId,
              groupKey: groupKey,
              type: 'product',
              name: card.getAttribute('data-bb-product-' + n + '-name') || '',
              variant: card.getAttribute('data-bb-product-' + n + '-variant-label') || '',
              image: card.getAttribute('data-bb-product-' + n + '-image') || '',
              price: parseFloat(card.getAttribute('data-bb-product-' + n + '-price')) || 0,
              quantity: 1,
              swatchesSource: swatchesSource,
              products: [{ id: parseInt(variantId, 10), quantity: 1 }],
            });
          });
        } else {
          var variantId = card.getAttribute('data-bb-variant-id');
          var swatchesSource = card.querySelector('[data-bb-swatches]');
          state.items.push({
            key: groupKey,
            groupKey: groupKey,
            type: type,
            name: card.getAttribute('data-bb-name'),
            variant: card.getAttribute('data-bb-variant-label') || '',
            image: card.getAttribute('data-bb-image'),
            price: parseFloat(card.getAttribute('data-bb-price')) || 0,
            quantity: 1,
            swatchesSource: swatchesSource,
            products: variantId ? [{ id: parseInt(variantId, 10), quantity: 1 }] : [],
          });
        }
        render();
      });
    });

    function removeItem(index) {
      state.items.splice(index, 1);
      render();
    }

    function removeGroup(groupKey) {
      state.items = state.items.filter(function (item) {
        return item.groupKey !== groupKey;
      });
      render();
    }

    function changeQuantity(index, delta) {
      var item = state.items[index];
      if (!item) return;
      var next = (item.quantity || 1) + delta;
      if (next < 1) {
        removeItem(index);
        return;
      }
      item.quantity = next;
      render();
    }

    /* ---------- Clear all ---------- */
    root.querySelectorAll('[data-bb-clear]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.items = [];
        render();
      });
    });

    /* ---------- Mobile sticky bar expand/collapse ---------- */
    root.querySelectorAll('[data-bb-sticky-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!stickyExpand) return;
        var isOpen = stickyExpand.classList.toggle('is-open');
        root.querySelectorAll('[data-bb-toggle-label]').forEach(function (label) {
          label.textContent = isOpen ? collapseLabel : expandLabel;
        });
        var emptySticky = root.querySelector('.bb-sticky[data-bb-sticky]');
        if (emptySticky) {
          emptySticky.style.display = isOpen ? 'none' : '';
        }
        if (isOpen) {
          document.body.classList.add('sticky-collagen');
          document.body.classList.remove('sticky-expand');
        } else {
          document.body.classList.add('sticky-expand');
          document.body.classList.remove('sticky-collagen');
        }
      });
    });

    if (stickyBar) {
      var stickyInfo = stickyBar.querySelector('.bb-sticky__info');
      if (stickyInfo) {
        stickyInfo.addEventListener('click', function () {
          if (!stickyExpand) return;
          stickyExpand.classList.add('is-open');
          document.body.classList.add('sticky-collagen');
          root.querySelectorAll('[data-bb-toggle-label]').forEach(function (label) {
            label.textContent = collapseLabel;
          });
          var emptySticky = root.querySelector('.bb-sticky[data-bb-sticky]');
          if (emptySticky) {
            emptySticky.style.display = 'none';
          }
        });
      }
    }

    /* ---------- Render ---------- */
    function render() {
      syncButtons();
      renderPicks();
      renderReminder();
      renderTiers();
      renderAmounts();
      renderSticky();
    }

    function syncButtons() {
      var activeGroupKeys = state.items.map(function (i) {
        return i.groupKey;
      });
      root.querySelectorAll('[data-bb-add]').forEach(function (btn) {
        var card = btn.closest('.bb-card');
        if (!card) return;
        var groupKey = card.getAttribute('data-bb-type') + ':' + card.getAttribute('data-bb-id');
        var isAdded = activeGroupKeys.indexOf(groupKey) > -1;
        btn.classList.toggle('is-added', isAdded);
        var cardImage = card.querySelector('.bb-card__image');
        if (cardImage) cardImage.classList.toggle('added-border', isAdded);
        btn.innerHTML = isAdded ? '<span>' + (config.addedLabel || 'Added in your set') + '</span>' : btn.getAttribute('data-original-label');
      });
    }

    function buildItemRow(item, index) {
      if (!itemRowTemplate) return null;
      var fragment = itemRowTemplate.content.cloneNode(true);
      var row = fragment.querySelector('.bb-item-row');
      var img = row.querySelector('.bb-item-row__media img');
      if (img) {
        img.src = item.image || '';
        img.alt = item.name || '';
      }
      var name = row.querySelector('.bb-item-row__name');
      if (name) name.textContent = item.name || '';
      var variantLine = row.querySelector('[data-bb-variant-line]');
      var variantText = row.querySelector('[data-bb-variant-text]');
      var editBtn = row.querySelector('[data-bb-row-edit]');
      var editPanel = row.querySelector('[data-bb-row-edit-panel]');
      var hasSwatches = !!(item.swatchesSource && item.swatchesSource.querySelectorAll('[data-bb-swatch]').length > 1);

      if (variantText) variantText.textContent = item.variant || '';
      if (variantLine) variantLine.hidden = !item.variant && !hasSwatches;
      if (editPanel) editPanel.hidden = true;

      if (editBtn) {
        editBtn.hidden = !hasSwatches;
        if (hasSwatches) {
          editBtn.addEventListener('click', function () {
            if (!editPanel) return;
            var willOpen = editPanel.hidden;
            if (willOpen) buildEditPanel(item, editPanel);
            editPanel.hidden = !willOpen;
          });
        }
      }

      var qtyValue = row.querySelector('.bb-item-row__qty-value');
      if (qtyValue) qtyValue.textContent = item.quantity || 1;

      var minusBtn = row.querySelector('[data-bb-qty-minus]');
      if (minusBtn) {
        minusBtn.addEventListener('click', function () {
          changeQuantity(index, -1);
        });
      }

      var plusBtn = row.querySelector('[data-bb-qty-plus]');
      if (plusBtn) {
        plusBtn.addEventListener('click', function () {
          changeQuantity(index, 1);
        });
      }

      var removeBtn = row.querySelector('[data-bb-row-remove]');
      if (removeBtn) {
        removeBtn.addEventListener('click', function () {
          removeItem(index);
        });
      }

      var price = row.querySelector('.bb-item-row__price');
      if (price) price.textContent = formatMoney(item.price * (item.quantity || 1));

      return row;
    }

    function buildEditPanel(item, panelEl) {
      panelEl.innerHTML = '';
      if (!item.swatchesSource) return;

      var clone = item.swatchesSource.cloneNode(true);
      var swatches = clone.querySelectorAll('[data-bb-swatch]');
      var currentId = item.products[0] && item.products[0].id;

      swatches.forEach(function (swatch) {
        var isActive = String(swatch.getAttribute('data-variant-id')) === String(currentId);
        swatch.classList.toggle('is-active', isActive);

        swatch.addEventListener('click', function () {
          swatches.forEach(function (s) {
            s.classList.toggle('is-active', s === swatch);
          });

          var variantId = parseInt(swatch.getAttribute('data-variant-id'), 10);
          var price = parseFloat(swatch.getAttribute('data-price'));
          var image = swatch.getAttribute('data-image');
          var label = swatch.getAttribute('aria-label');

          if (item.products[0] && variantId) item.products[0].id = variantId;
          if (!isNaN(price)) item.price = price;
          if (image) item.image = image;
          if (label) item.variant = label;

          render();
        });
      });

      panelEl.appendChild(clone);
    }

    function renderSlotContents(slotsContainer) {
      var slotEls = slotsContainer.querySelectorAll('[data-bb-empty-slot]');
      slotEls.forEach(function (slotEl, index) {
        var item = state.items[index];
        slotEl.innerHTML = '';

        if (item) {
          slotEl.classList.add('is-filled');

          var img = document.createElement('img');
          img.className = 'bb-slot__image';
          img.src = item.image || '';
          img.alt = item.name || '';
          slotEl.appendChild(img);

          var qty = item.quantity || 1;
          if (qty > 1) {
            var badge = document.createElement('span');
            badge.className = 'bb-slot__qty-badge';
            badge.textContent = qty;
            slotEl.appendChild(badge);
          }
        } else {
          slotEl.classList.remove('is-filled');
          var plus = document.createElement('span');
          plus.className = 'bb-slot__plus';
          slotEl.appendChild(plus);
        }
      });
    }

    function renderPicks() {
      var hasItems = state.items.length > 0;
      root.querySelectorAll('[data-bb-slots]').forEach(function (slots) {
        slots.hidden = hasItems;
        renderSlotContents(slots);
      });
      root.querySelectorAll('[data-bb-item-list]').forEach(function (list) {
        if (!hasItems) {
          list.hidden = true;
          list.innerHTML = '';
          return;
        }
        list.hidden = false;
        list.innerHTML = '';
        state.items.forEach(function (item, index) {
          var row = buildItemRow(item, index);
          if (row) list.appendChild(row);
        });
      });
    }

    function renderReminder() {
      var qty = totalQuantity();
      var html;

      if (qty === 0) {
        html = 'Add 2 item to get <strong>' + tier2Percent + '% Off</strong>';
      } else if (qty >= 3) {
        html = '<strong>' + escapeHtml(reminderMax) + '</strong>';
      } else {
        var needed = qty < 2 ? 2 - qty : 3 - qty;
        var percent = qty < 2 ? tier2Percent : tier3Percent;
        var text = reminderTemplate
          .replace('[count]', needed)
          .replace('[plural]', needed === 1 ? '' : 's')
          .replace('[percent]', percent);

        var percentToken = percent + '%';
        var safeText = escapeHtml(text);
        var safeToken = escapeHtml(percentToken) + ' off';
        html = safeText.replace(safeToken, '<strong>' + safeToken + '</strong>');
      }

      root.querySelectorAll('[data-bb-reminder]').forEach(function (el) {
        el.innerHTML = html;
      });
      root.querySelectorAll('[data-bb-reminder-inline]').forEach(function (el) {
        el.innerHTML = html;
      });
    }

    function renderTiers() {
      var qty = totalQuantity();
      var tierEls = Array.prototype.slice.call(root.querySelectorAll('[data-bb-tier]'));
      var thresholds = tierEls
        .map(function (tier) {
          return parseInt(tier.getAttribute('data-bb-tier'), 10);
        })
        .sort(function (a, b) {
          return a - b;
        });

      tierEls.forEach(function (tier) {
        var threshold = parseInt(tier.getAttribute('data-bb-tier'), 10);
        var fill = tier.querySelector('[data-bb-tier-fill]');
        var reached = qty >= threshold;

        var index = thresholds.indexOf(threshold);
        var previousThreshold = index > 0 ? thresholds[index - 1] : 0;
        var span = threshold - previousThreshold || 1;
        var progress = qty > previousThreshold ? Math.min((qty - previousThreshold) / span, 1) * 100 : 0;

        if (fill) fill.style.width = progress + '%';
        tier.classList.toggle('is-reached', reached);
      });
    }

    function renderAmounts() {
      var subtotal = subtotalCents();
      var percent = getDiscountPercent(totalQuantity());
      var discount = Math.round((subtotal * percent) / 100);
      var total = subtotal - discount;
      var qty = totalQuantity();

      root.querySelectorAll('[data-bb-subtotal]').forEach(function (el) {
        if (window.innerWidth <= 989 && qty >= 2 && discount > 0) {
          el.innerHTML =
            formatMoney(total)
            +
            '<span class="bb-subtotal__compare"><s>' +
            formatMoney(subtotal) +
            '</s></span> ';
        } else {
          el.textContent = formatMoney(subtotal);
        }
      });
      setAllText('[data-bb-discount]', discount > 0 ? '-' + formatMoney(discount) : formatMoney(0));
      setAllText('[data-bb-total]', formatMoney(total));

      root.querySelectorAll('[data-bb-discount-message]').forEach(function (el) {
        if (discount > 0 && percent > 0) {
          var text = discountMessageTemplate
            .replace('[amount]', formatMoney(discount))
            .replace('[percent]', percent);

          var amountToken = formatMoney(discount);
          var percentToken = percent + '% off applied';
          var safeText = escapeHtml(text);
          var safeAmount = escapeHtml(amountToken);
          var safePercent = escapeHtml(percentToken);

          safeText = safeText.replace(safeAmount, '<strong>' + safeAmount + '</strong>');
          safeText = safeText.replace(safePercent, '<strong>' + safePercent + '</strong>');

          el.innerHTML = safeText;
          el.hidden = false;
          el.classList.add('is-visible');
        } else {
          el.innerHTML = '';
          el.hidden = true;
          el.classList.remove('is-visible');
        }
      });

      root.querySelectorAll('[data-bb-finalize]').forEach(function (btn) {
        btn.disabled = state.items.length === 0;
      });
    }
    window.addEventListener('resize', renderAmounts);

    function setAllText(selector, text) {
      root.querySelectorAll(selector).forEach(function (el) {
        el.textContent = text;
      });
    }

    function renderSticky() {
      if (!stickyBar) return;
      var qty = totalQuantity();
      var countEl = stickyBar.querySelector('[data-bb-sticky-count]');
      var totalEl = stickyBar.querySelector('[data-bb-sticky-total]');
      var cta = stickyBar.querySelector('[data-bb-sticky-cta]');

      if (qty === 0) {
        stickyBar.classList.add('is-empty');
        if (countEl) countEl.textContent = config.stickyEmptyLabel || 'No items selected';
        if (totalEl) totalEl.textContent = '';
        if (cta) cta.disabled = true;
      } else {
        stickyBar.classList.remove('is-empty');
        var subtotal = subtotalCents();
        var percent = getDiscountPercent(qty);
        var total = subtotal - Math.round((subtotal * percent) / 100);
        if (countEl) countEl.textContent = qty + (qty === 1 ? ' item selected' : ' items selected');
        if (totalEl) totalEl.textContent = formatMoney(total);
        if (cta) cta.disabled = false;
      }
    }

    /* ---------- Finalize: go straight to checkout via a cart permalink (no AJAX add-to-cart call, so nothing can intercept it and pop the cart drawer) ---------- */
    function finalize(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      }
      suppressCartPopup();
      if (state.items.length === 0) return;

      var quantities = {};
      state.items.forEach(function (item) {
        item.products.forEach(function (p) {
          var qty = (p.quantity || 1) * (item.quantity || 1);
          quantities[p.id] = (quantities[p.id] || 0) + qty;
        });
      });

      var variantIds = Object.keys(quantities);
      if (!variantIds.length) return;

      var buttons = root.querySelectorAll('[data-bb-finalize], [data-bb-sticky-cta]');
      buttons.forEach(function (b) {
        b.disabled = true;
      });

      try {
        sessionStorage.setItem(PENDING_CHECKOUT_KEY, JSON.stringify(quantities));
      } catch (e) {
        /* ignore */
      }

      var permalinkItems = variantIds
        .map(function (id) {
          return id + ':' + quantities[id];
        })
        .join(',');

      var qty = totalQuantity();
      var discountCode = qty >= 3 ? tier3DiscountCode : qty === 2 ? tier2DiscountCode : '';

      /* A cart permalink (/cart/{variant}:{qty},...) redirects straight to checkout by default - */
      /* no /checkout suffix exists in Shopify's syntax, and appending one 404s the route. */
      var url = '/cart/' + permalinkItems;
      if (discountCode) {
        url += '?discount=' + encodeURIComponent(discountCode);
      }

      window.location.href = url;
    }

    root.querySelectorAll('[data-bb-finalize], [data-bb-sticky-cta]').forEach(function (btn) {
      btn.addEventListener('click', finalize);
    });

    /* ---------- Quick View ---------- */
    function initQuickView() {
      var shell = root.querySelector('[data-bb-quickview-root]');
      if (!shell) return;

      var mount = shell.querySelector('[data-bb-quickview-mount]');
      var titleEl = shell.querySelector('[data-bb-quickview-title]');
      var addBtn = shell.querySelector('[data-bb-quickview-add]');
      var closeBtn = shell.querySelector('[data-bb-quickview-close]');
      var overlay = shell.querySelector('[data-bb-quickview-overlay]');

      var qvGroupKey = null;
      var qvItems = [];

      function renderQuickViewAmounts() {
        if (addBtn) addBtn.disabled = qvItems.length === 0;
      }
      function initGalleryScrollbar() {
        var gallery = mount.querySelector('[data-bb-quickview-gallery]');
        var galleryWrap = mount.querySelector('[data-bb-quickview-gallery-wrap]');
        var scrollbar = mount.querySelector('[data-bb-quickview-gallery-scrollbar]');
        var thumb = mount.querySelector('[data-bb-quickview-gallery-thumb]');
        if (!galleryWrap) return;

        var count = gallery ? gallery.children.length : 0;
        galleryWrap.hidden = count === 0;
        if (!gallery) return;
        gallery.querySelectorAll('img').forEach(function (img) {
          img.setAttribute('draggable', 'false');
          img.addEventListener('dragstart', function (e) {
            e.preventDefault();
          });
        });

        if (!thumb || count <= 1) return;

        var ticking = false;
        function updateThumb() {
          ticking = false;
          var max = gallery.scrollWidth - gallery.clientWidth;
          if (max <= 0) {
            thumb.style.width = '100%';
            thumb.style.marginLeft = '0';
            return;
          }
          var ratio = gallery.scrollLeft / max;
          var thumbWidth = Math.max(15, (gallery.clientWidth / gallery.scrollWidth) * 100);
          thumb.style.width = thumbWidth + '%';
          thumb.style.marginLeft = ratio * (100 - thumbWidth) + '%';
        }
        function onGalleryScroll() {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(updateThumb);
        }

        gallery.addEventListener('scroll', onGalleryScroll, { passive: true });
        requestAnimationFrame(function () {
          requestAnimationFrame(updateThumb);
        });

        /* ---- Click-and-drag the gallery itself to scroll it ---- */
        var galleryDragging = false;
        var galleryStartX = 0;
        var galleryStartScroll = 0;
        var draggedPastThreshold = false;

        gallery.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          galleryDragging = true;
          draggedPastThreshold = false;
          galleryStartX = e.clientX;
          galleryStartScroll = gallery.scrollLeft;
          gallery.classList.add('is-dragging');
          gallery.setPointerCapture(e.pointerId);
        });
        gallery.addEventListener('pointermove', function (e) {
          if (!galleryDragging) return;
          var deltaX = e.clientX - galleryStartX;
          if (Math.abs(deltaX) > 3) draggedPastThreshold = true;
          gallery.scrollLeft = galleryStartScroll - deltaX;
        });
        function endGalleryDrag() {
          galleryDragging = false;
          gallery.classList.remove('is-dragging');
        }
        gallery.addEventListener('pointerup', endGalleryDrag);
        gallery.addEventListener('pointercancel', endGalleryDrag);
        gallery.addEventListener('lostpointercapture', endGalleryDrag);
        gallery.addEventListener('click',
          function (e) {
            if (draggedPastThreshold) {
              e.preventDefault();
              e.stopPropagation();
            }
          },
          true
        );

        /* ---- Drag the thumb to control the gallery ---- */
        var thumbDragging = false;
        var thumbStartX = 0;
        var thumbStartScroll = 0;

        thumb.addEventListener('pointerdown', function (e) {
          e.preventDefault();
          e.stopPropagation();
          thumbDragging = true;
          thumbStartX = e.clientX;
          thumbStartScroll = gallery.scrollLeft;
          thumb.classList.add('is-dragging');
          thumb.setPointerCapture(e.pointerId);
        });
        thumb.addEventListener('pointermove', function (e) {
          if (!thumbDragging) return;
          var trackWidth = scrollbar ? scrollbar.clientWidth : gallery.clientWidth;
          var maxThumbMove = trackWidth - thumb.offsetWidth;
          var maxScroll = gallery.scrollWidth - gallery.clientWidth;
          if (maxThumbMove <= 0 || maxScroll <= 0) return;
          var deltaX = e.clientX - thumbStartX;
          gallery.scrollLeft = thumbStartScroll + (deltaX / maxThumbMove) * maxScroll;
        });
        function endThumbDrag() {
          thumbDragging = false;
          thumb.classList.remove('is-dragging');
        }
        thumb.addEventListener('pointerup', endThumbDrag);
        thumb.addEventListener('pointercancel', endThumbDrag);
        thumb.addEventListener('lostpointercapture', endThumbDrag);

        /* ---- Click on the scrollbar track (not the thumb) to jump ---- */
        if (scrollbar) {
          scrollbar.addEventListener('pointerdown', function (e) {
            if (e.target === thumb) return;
            var rect = scrollbar.getBoundingClientRect();
            var clickX = e.clientX - rect.left;
            var maxScroll = gallery.scrollWidth - gallery.clientWidth;
            var maxThumbMove = scrollbar.clientWidth - thumb.offsetWidth;
            if (maxScroll <= 0 || maxThumbMove <= 0) return;
            var percentage = Math.max(0, Math.min(1, (clickX - thumb.offsetWidth / 2) / maxThumbMove));
            gallery.scrollLeft = percentage * maxScroll;
          });
        }
      }

      function buildQvItem(el) {
        var item = {
          el: el,
          name: el.getAttribute('data-name'),
          image: el.getAttribute('data-image'),
          variantId: parseInt(el.getAttribute('data-variant-id'), 10),
          price: parseFloat(el.getAttribute('data-price')) || 0,
          quantity: 1,
        };

        var qtyValueEl = el.querySelector('[data-bb-quickview-qty-value]');
        var priceEl = el.querySelector('[data-bb-quickview-item-price]');

        function syncDisplay() {
          if (qtyValueEl) qtyValueEl.textContent = item.quantity;
          if (priceEl) priceEl.textContent = formatMoney(item.price * item.quantity);
          renderQuickViewAmounts();
        }

        var minusBtn = el.querySelector('[data-bb-quickview-qty-minus]');
        var plusBtn = el.querySelector('[data-bb-quickview-qty-plus]');
        if (minusBtn) {
          minusBtn.addEventListener('click', function () {
            if (item.quantity <= 1) return;
            item.quantity -= 1;
            syncDisplay();
          });
        }
        if (plusBtn) {
          plusBtn.addEventListener('click', function () {
            item.quantity += 1;
            syncDisplay();
          });
        }

        el.querySelectorAll('[data-bb-swatch]').forEach(function (swatch) {
          swatch.addEventListener('click', function () {
            el.querySelectorAll('[data-bb-swatch]').forEach(function (s) {
              s.classList.toggle('is-active', s === swatch);
            });
            var variantId = parseInt(swatch.getAttribute('data-variant-id'), 10);
            var price = parseFloat(swatch.getAttribute('data-price'));
            var image = swatch.getAttribute('data-image');
            var label = swatch.getAttribute('aria-label');
            var variantTextEl = el.querySelector('[data-bb-quickview-item-variant-text]');
            if (variantId) item.variantId = variantId;
            if (!isNaN(price)) item.price = price;
            if (image) item.image = image;
            if (label && variantTextEl) variantTextEl.textContent = label;
            syncDisplay();
          });
        });

        syncDisplay();
        return item;
      }

      function openQuickView(triggerId, triggerType) {
        var template = root.querySelector('[data-bb-quickview-content][data-bb-quickview-id="' + triggerId + '"]');
        if (!template || !mount) return;

        qvGroupKey = (triggerType || template.getAttribute('data-bb-quickview-type') || 'product') + ':' + triggerId;
        qvItems = [];

        mount.innerHTML = '';
        mount.appendChild(template.content.cloneNode(true));

        if (titleEl) titleEl.textContent = template.getAttribute('data-bb-quickview-title') || '';

        mount.querySelectorAll('[data-bb-quickview-item]').forEach(function (el) {
          qvItems.push(buildQvItem(el));
        });

        renderQuickViewAmounts();

        shell.hidden = false;
        requestAnimationFrame(function () {
          shell.classList.add('is-open');
        });
        initGalleryScrollbar();
        document.body.classList.add('bb-quickview-open');
      }

      function closeQuickView() {
        shell.classList.remove('is-open');
        document.body.classList.remove('bb-quickview-open');
        window.setTimeout(function () {
          if (!shell.classList.contains('is-open')) shell.hidden = true;
        }, 300);
      }

      root.querySelectorAll('[data-bb-quickview]').forEach(function (trigger) {
        var open = function () {
          var card = trigger.closest('.bb-card');
          var type = card ? card.getAttribute('data-bb-type') : null;
          openQuickView(trigger.getAttribute('data-bb-quickview'), type);
        };
        trigger.addEventListener('click', open);
        trigger.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            open();
          }
        });
      });

      if (closeBtn) closeBtn.addEventListener('click', closeQuickView);
      if (overlay) overlay.addEventListener('click', closeQuickView);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && shell.classList.contains('is-open')) closeQuickView();
      });

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          if (!qvItems.length || !qvGroupKey) return;

          state.items = state.items.filter(function (i) {
            return i.groupKey !== qvGroupKey;
          });

          qvItems.forEach(function (item) {
            var variantTextEl = item.el.querySelector('[data-bb-quickview-item-variant-text]');
            state.items.push({
              key: 'product:' + item.variantId + ':' + qvGroupKey,
              groupKey: qvGroupKey,
              type: 'product',
              name: item.name || '',
              variant: variantTextEl ? variantTextEl.textContent : '',
              image: item.image || '',
              price: item.price || 0,
              quantity: item.quantity || 1,
              swatchesSource: item.el.querySelector('[data-bb-swatches]'),
              products: item.variantId ? [{ id: item.variantId, quantity: 1 }] : [],
            });
          });

          render();
          closeQuickView();
        });
      }
    }

    initQuickView();

    render();
  }

  document.querySelectorAll('[id^="BundleBuilder-"]').forEach(initBundleBuilder);
  
  // === START: Scrollbar Js === // 
  (() => {
    const categories = document.querySelector('.bb-categories');
    if (!categories) {
      return;
    }
    document.querySelector('#bb-console-scrollbar')?.remove();
    const scrollbar = document.createElement('div');
    scrollbar.id = 'bb-console-scrollbar';
    const thumb = document.createElement('div');
    thumb.id = 'bb-console-scrollbar-thumb';
    scrollbar.appendChild(thumb);
    categories.insertAdjacentElement('afterend', scrollbar);
    Object.assign(categories.style, {
      overflowX: 'auto',
      overflowY: 'hidden',
      WebkitOverflowScrolling: 'touch',
      touchAction: 'pan-x'
    });
    function updateScrollbar() {
      const scrollWidth = categories.scrollWidth;
      const visibleWidth = categories.clientWidth;
      const trackWidth = scrollbar.clientWidth;
      if ( scrollWidth <= 0 || visibleWidth <= 0 || trackWidth <= 0) {
        return;
      }
      const maxScroll = scrollWidth - visibleWidth;
      if (maxScroll <= 1) {
        scrollbar.style.display = 'none';
        return;
      }
      scrollbar.style.display = 'block';
      let thumbWidth = (visibleWidth / scrollWidth) * trackWidth;
      thumbWidth = Math.max( thumbWidth,20);
      thumbWidth = Math.min( thumbWidth, trackWidth);
      thumb.style.width = `${thumbWidth}px`;
      const maxThumbMove = trackWidth - thumbWidth;
      if (maxThumbMove <= 0) {
        thumb.style.transform ='translate3d(0, 0, 0)';
        return;
      }
      const percentage = categories.scrollLeft / maxScroll;
      const thumbPosition = percentage * maxThumbMove;
      thumb.style.transform = `translate3d(${thumbPosition}px, 0, 0)`;
    }
    categories.addEventListener( 'scroll', updateScrollbar, { passive: true });
    let dragging = false;
    let startX = 0;
    let startScroll = 0;
    thumb.addEventListener('pointerdown',(e) => {
        e.preventDefault();
        dragging = true;
        startX = e.clientX;
        startScroll = categories.scrollLeft;
        thumb.style.cursor = 'grabbing';
        thumb.setPointerCapture(e.pointerId);
      }
    );
    thumb.addEventListener( 'pointermove',(e) => { 
        if (!dragging) {
          return;
        }
        e.preventDefault();
        const maxScroll = categories.scrollWidth - categories.clientWidth;
        const trackWidth = scrollbar.clientWidth;
        const thumbWidth = thumb.offsetWidth;
        const maxThumbMove = trackWidth - thumbWidth;
        if ( maxScroll <= 0 || maxThumbMove <= 0) {
          return;
        }
        const moveX = e.clientX - startX;
        categories.scrollLeft = startScroll + (moveX / maxThumbMove) * maxScroll;
        updateScrollbar();
      }
    );
    function stopDragging() {
      dragging = false;
      thumb.style.cursor = 'grab';
    }
    thumb.addEventListener( 'pointerup', stopDragging);
    thumb.addEventListener('pointercancel', stopDragging);
    thumb.addEventListener( 'lostpointercapture', stopDragging);
    scrollbar.addEventListener('pointerdown', (e) => {
        if (e.target === thumb) {
          return;
        }
        const rect = scrollbar.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const maxScroll = categories.scrollWidth - categories.clientWidth;
        const thumbWidth = thumb.offsetWidth;
        const trackWidth = scrollbar.clientWidth;
        const maxThumbMove = trackWidth - thumbWidth;
        if ( maxScroll <= 0 || maxThumbMove <= 0) {
          return;
        }
        let percentage = (clickX - thumbWidth / 2) / maxThumbMove;
        percentage = Math.max( 0, Math.min(1, percentage));
        categories.scrollLeft = percentage * maxScroll;
        updateScrollbar();
      }
    );
    window.addEventListener( 'resize', updateScrollbar);
    const resizeObserver =
      new ResizeObserver(() => {
        requestAnimationFrame(
          updateScrollbar
        );
      });
    resizeObserver.observe(categories);
    const mutationObserver =
      new MutationObserver(() => {
        requestAnimationFrame(() => {
          updateScrollbar();
        });
      });
    mutationObserver.observe(
      categories,
      {
        childList: true,
        subtree: true
      }
    );
    if (document.fonts) {
      document.fonts.ready.then(() => {
        requestAnimationFrame(
          updateScrollbar
        );
      });
    }
    window.addEventListener(
      'load',
      () => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            updateScrollbar();
          });
        });
      }
    );
    function initialCheck() {
      updateScrollbar();
    }
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        initialCheck();
      });
    });
    setTimeout(initialCheck, 100);
    setTimeout(initialCheck, 300);
    setTimeout(initialCheck, 500);
    setTimeout(initialCheck, 800);
    setTimeout(initialCheck, 1200);
    setTimeout(initialCheck, 2000);
  })();
  // === END: Scrollbar Js === // 

})();
